import type { SVGProps } from "react";

export const ProgressCircleTodoIcon = ({
  opacity = "0.4",
  fill = "none",
  strokeColor = "#4A5466",
  ...props
}: SVGProps<SVGSVGElement> & {
  opacity?: string;
  fill?: string;
  strokeColor?: string;
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity={opacity}
      d="M8 15.5C3.85786 15.5 0.5 12.1422 0.5 8C0.5 3.85787 3.85787 0.5 8 0.5C12.1422 0.5 15.5 3.85786 15.5 8C15.5 12.1422 12.1422 15.5 8 15.5Z"
      stroke={strokeColor}
    />
  </svg>
);
